/* tslint:disable */

/**
 */
export class NotifyTypeFrom {
    id?: number;
    name?: string;
    key?: string;
    route_link?: string;
    url_img?: string;
}
